<!-- Formulaire inline de création rapide style Todoist -->
<div class="task-inline-create" *ngIf="visible">
  <div class="task-inline-create__form">
    <!-- Ligne 1 : Titre -->
    <div (keydown)="onTitleKeyDown($event)">
      <eva-input
        #titleInput
        [(value)]="title"
        [maxlength]="200"
        placeholder="Nom de la tâche"
        size="inline"
        [error]="titleError"
        class="task-inline-create__title-input"
      ></eva-input>
    </div>
    <small *ngIf="titleError" class="task-inline-create__error">{{ titleError }}</small>

    <!-- Contrôles en ligne : date, assigné à, lier à, urgent, privée -->
    <div class="task-inline-create__controls">
      <app-task-date-picker
        [(date)]="dueDate"
        [(plannedStartDate)]="plannedStartDate"
        [(dateMode)]="dateMode"
        placeholder="Date"
        [showClear]="true"
        [compact]="true"
      ></app-task-date-picker>

      <app-task-assignee-picker
        [(assignees)]="assignedTo"
        [employees]="employees"
        placeholder="Assigné à"
        [compact]="true"
      ></app-task-assignee-picker>

      <!-- Lier à -->
      <div class="task-inline-create__link-wrapper" *ngIf="!hideObjectLinks">
        <eva-button
          label="Lier à..."
          icon="heroLink"
          variant="text"
          size="small"
          (onClick)="toggleLinkSearch()"
        ></eva-button>
      </div>

      <app-task-priority-picker [(priority)]="urgency" [compact]="true"></app-task-priority-picker>

      <span class="task-inline-create__private">
        <eva-tag
          *ngIf="isPrivate"
          [preset]="privateTagPreset"
          size="small"
          [rounded]="true"
          tabindex="0"
          role="button"
          aria-label="Privée : rendre visible à l'équipe"
          (click)="togglePrivate()"
          (keydown.enter)="$event.preventDefault(); togglePrivate()"
          (keydown.space)="$event.preventDefault(); togglePrivate()"
          evaTooltip="Privée : visible seulement par vous et les assignés. Cliquer pour la rendre visible à l'équipe"
        ></eva-tag>
        <eva-button
          *ngIf="!isPrivate"
          icon="heroLockOpen"
          variant="text"
          size="small"
          severity="secondary"
          (onClick)="togglePrivate()"
          ariaLabel="Rendre privée"
          tooltip="Rendre privée : visible seulement par vous et les assignés"
        ></eva-button>
      </span>
    </div>

    <!-- Lier à : panneau de recherche sous la ligne d'actions, dans la carte -->
    <div
      class="task-inline-create__link-overlay"
      *ngIf="!hideObjectLinks && showLinkSearch"
      (click)="toggleLinkSearch()"
    ></div>

    <div class="task-inline-create__link-dropdown" *ngIf="!hideObjectLinks && showLinkSearch">
      <eva-input
        icon="heroMagnifyingGlass"
        [clearable]="true"
        placeholder="Rechercher un chantier, client, offre..."
        [value]="linkSearchQuery"
        (valueChange)="onLinkSearch($event)"
        [autofocus]="true"
      ></eva-input>
      <div class="task-inline-create__link-searching" *ngIf="isSearchingLinks">
        <i class="pi pi-spinner pi-spin"></i>
        <span>Recherche en cours...</span>
      </div>
      <div class="task-inline-create__link-results" *ngIf="linkSearchResults.length > 0">
        <div *ngFor="let group of linkSearchResults" class="task-inline-create__link-group">
          <div class="task-inline-create__link-group-label">
            <i class="pi" [ngClass]="group.object_type_icon"></i>
            {{ group.object_type_label }}
          </div>
          <button
            type="button"
            *ngFor="let item of group.items"
            class="task-inline-create__link-result-item"
            (click)="addObjectLink(group.object_type, item.object_id, item.label)"
          >
            {{ item.label }}
          </button>
        </div>
      </div>
    </div>

    <!-- Tags objets liés -->
    <div class="task-inline-create__link-tags" *ngIf="!hideObjectLinks && activeObjectsLinks.length > 0">
      <eva-tag
        *ngFor="let link of activeObjectsLinks"
        [preset]="{ label: link.object_name || link.object_type, severity: 'secondary' }"
        [removable]="true"
        (onRemove)="removeObjectLink(link.object_type, link.object_id)"
      ></eva-tag>
    </div>

    <!-- Ligne inférieure : boutons -->
    <div class="task-inline-create__footer">
      <div class="task-inline-create__actions">
        <eva-button label="Annuler" variant="outlined" severity="secondary" (onClick)="cancel()"></eva-button>
        <eva-button label="Ajouter" (onClick)="submit()" [loading]="saving" [disabled]="saving"></eva-button>
      </div>
    </div>
  </div>
</div>

<!-- Lien "+ tâche" (visible quand le formulaire est masqué et showTrigger activé) -->
<button *ngIf="showTrigger && !visible" type="button" class="task-inline-create__trigger" (click)="open()">
  <span class="task-inline-create__trigger-icon"><i class="pi pi-plus"></i></span>
  Ajouter une tâche
</button>
